import React, { useEffect } from 'react';
import { apiStatic } from 'AurionCR/components';
import axios, { AxiosRequestConfig } from 'axios';
import { api, normalizeDataBeforeSave } from 'utils/service';

const instances = [apiStatic, api, axios];
const patchDon5 = (conf: AxiosRequestConfig) => {
  if (conf.method === 'patch' && conf.data && typeof conf.data === 'object') {
    conf.data = Object.entries(normalizeDataBeforeSave(conf.data))
      .filter(([path, value]) => value !== undefined)
      .map(([path, value]) => {
        return { path, value };
      });
  }
  return conf;
};

export const AxiosInterceptorPatch: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  useEffect(() => {
    instances.map((instance) => {
      return instance.interceptors.request.use(patchDon5);
    });
  }, []);

  return <>{children}</>;
};
